"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepAndSendDataToJSON = exports.PrepAndSendDataFromJSONTyped = exports.PrepAndSendDataFromJSON = exports.instanceOfPrepAndSendData = exports.attributeTypeMapPrepAndSendData = void 0;
var RecipientItemsJoined_1 = require("./RecipientItemsJoined");
var CoverPage_1 = require("./CoverPage");
var ModelFile_1 = require("./ModelFile");
var BulkSend_1 = require("./BulkSend");
var EditorFields_1 = require("./EditorFields");
var Document_1 = require("./Document");
var CCItemsJoined_1 = require("./CCItemsJoined");
var Settings_1 = require("./Settings");
var Template_1 = require("./Template");
exports.attributeTypeMapPrepAndSendData = [
    {
        name: "guid",
        type: "string",
    },
    {
        name: "settings",
        type: "Settings",
    },
    {
        name: "editorFields",
        type: "EditorFields",
    },
    {
        name: "files",
        type: "Array<ModelFile>",
    },
    {
        name: "recipients",
        type: "Array<RecipientItemsJoined>",
    },
    {
        name: "ccs",
        type: "Array<CCItemsJoined>",
    },
    {
        name: "document",
        type: "Document",
    },
    {
        name: "templates",
        type: "Array<Template>",
    },
    {
        name: "coverPage",
        type: "CoverPage",
    },
    {
        name: "bulkSend",
        type: "BulkSend",
    },
    {
        name: "isMeOnly",
        type: "boolean",
    },
    {
        name: "shouldConvertDocToTemplate",
        type: "boolean",
    },
];
/**
 * Check if a given object implements the PrepAndSendData interface.
 */
function instanceOfPrepAndSendData(value) {
    if (!("guid" in value) || value["guid"] === undefined)
        return false;
    if (!("settings" in value) || value["settings"] === undefined)
        return false;
    if (!("editorFields" in value) || value["editorFields"] === undefined)
        return false;
    if (!("files" in value) || value["files"] === undefined)
        return false;
    if (!("recipients" in value) || value["recipients"] === undefined)
        return false;
    if (!("ccs" in value) || value["ccs"] === undefined)
        return false;
    if (!("document" in value) || value["document"] === undefined)
        return false;
    if (!("templates" in value) || value["templates"] === undefined)
        return false;
    if (!("coverPage" in value) || value["coverPage"] === undefined)
        return false;
    if (!("bulkSend" in value) || value["bulkSend"] === undefined)
        return false;
    if (!("isMeOnly" in value) || value["isMeOnly"] === undefined)
        return false;
    if (!("shouldConvertDocToTemplate" in value) ||
        value["shouldConvertDocToTemplate"] === undefined)
        return false;
    return true;
}
exports.instanceOfPrepAndSendData = instanceOfPrepAndSendData;
function PrepAndSendDataFromJSON(json) {
    return PrepAndSendDataFromJSONTyped(json, false);
}
exports.PrepAndSendDataFromJSON = PrepAndSendDataFromJSON;
function PrepAndSendDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        guid: json["guid"],
        settings: (0, Settings_1.SettingsFromJSON)(json["settings"]),
        editorFields: (0, EditorFields_1.EditorFieldsFromJSON)(json["editor_fields"]),
        files: json["files"].map(ModelFile_1.ModelFileFromJSON),
        recipients: json["recipients"].map(RecipientItemsJoined_1.RecipientItemsJoinedFromJSON),
        ccs: json["ccs"].map(CCItemsJoined_1.CCItemsJoinedFromJSON),
        document: (0, Document_1.DocumentFromJSON)(json["document"]),
        templates: json["templates"].map(Template_1.TemplateFromJSON),
        coverPage: (0, CoverPage_1.CoverPageFromJSON)(json["cover_page"]),
        bulkSend: (0, BulkSend_1.BulkSendFromJSON)(json["bulk_send"]),
        isMeOnly: json["is_me_only"],
        shouldConvertDocToTemplate: json["should_convert_doc_to_template"],
    };
}
exports.PrepAndSendDataFromJSONTyped = PrepAndSendDataFromJSONTyped;
function PrepAndSendDataToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        guid: value["guid"],
        settings: (0, Settings_1.SettingsToJSON)(value["settings"]),
        editor_fields: (0, EditorFields_1.EditorFieldsToJSON)(value["editorFields"]),
        files: value["files"].map(ModelFile_1.ModelFileToJSON),
        recipients: value["recipients"].map(RecipientItemsJoined_1.RecipientItemsJoinedToJSON),
        ccs: value["ccs"].map(CCItemsJoined_1.CCItemsJoinedToJSON),
        document: (0, Document_1.DocumentToJSON)(value["document"]),
        templates: value["templates"].map(Template_1.TemplateToJSON),
        cover_page: (0, CoverPage_1.CoverPageToJSON)(value["coverPage"]),
        bulk_send: (0, BulkSend_1.BulkSendToJSON)(value["bulkSend"]),
        is_me_only: value["isMeOnly"],
        should_convert_doc_to_template: value["shouldConvertDocToTemplate"],
    };
}
exports.PrepAndSendDataToJSON = PrepAndSendDataToJSON;
